(function () {
  const SIZE_RECO_SELECTOR = "[data-size-reco]";
  const MAP_SELECTOR = "[data-size-reco-map]";
  const TEXT_SELECTOR = "[data-size-reco-text]";

  const cssEscape = (value) => {
    if (window.CSS && CSS.escape) {
      return CSS.escape(value);
    }
    return value.replace(/["\\]/g, "\\$&");
  };

  const normalize = (value) => {
    if (typeof value !== "string") {
      return "";
    }
    return value.trim().toLowerCase();
  };

  const getMap = (container) => {
    if (container._sizeRecoMapParsed) {
      return container._sizeRecoMap;
    }

    const script = container.querySelector(MAP_SELECTOR);
    container._sizeRecoMapParsed = true;

    if (!script) {
      container._sizeRecoMap = null;
      return null;
    }

    try {
      container._sizeRecoMap = JSON.parse(script.textContent || "{}");
    } catch (error) {
      container._sizeRecoMap = null;
    }

    return container._sizeRecoMap;
  };

  const findEntry = (map, sizeValue) => {
    if (!map || typeof map !== "object") {
      return null;
    }

    if (map[sizeValue] != null) {
      return map[sizeValue];
    }

    const normalizedSize = normalize(sizeValue);
    const matchedKey = Object.keys(map).find((key) => normalize(key) === normalizedSize);

    return matchedKey ? map[matchedKey] : null;
  };

  const formatKeyLabel = (key) => key.replace(/_/g, " ").toUpperCase();

  const buildMeasurementItems = (entry) => {
    if (!entry || typeof entry !== "object") {
      return [];
    }

    const keys = Object.keys(entry);
    if (keys.length === 0) {
      return [];
    }

    const items = [];
    keys.forEach((key) => {
      if (key == null) {
        return;
      }

      const rawValue = entry[key];
      if (rawValue == null) {
        return;
      }

      let valueText = "";
      if (typeof rawValue === "object") {
        try {
          valueText = JSON.stringify(rawValue);
        } catch (error) {
          valueText = "";
        }
      } else {
        valueText = String(rawValue);
      }

      const trimmedValue = valueText.trim();
      const trimmedKey = String(key).trim();

      if (!trimmedKey || !trimmedValue) {
        return;
      }

      items.push({
        label: formatKeyLabel(trimmedKey),
        value: trimmedValue,
      });
    });

    return items;
  };

  const renderDefaultMessage = (textEl, message) => {
    if (!textEl) {
      return;
    }

    textEl.textContent = message || "";
  };

  const renderItems = (textEl, items) => {
    if (!textEl) {
      return;
    }

    textEl.textContent = "";

    const fragment = document.createDocumentFragment();
    items.forEach((item) => {
      const span = document.createElement("span");
      span.className = "product-size-reco__item";
      span.textContent = `${item.label}: ${item.value}`;
      fragment.appendChild(span);
    });

    textEl.appendChild(fragment);
  };

  const getSelectedSizeValue = (picker, optionName, optionPosition) => {
    if (!picker || !optionName || !optionPosition) {
      return "";
    }

    const inputName = `${optionName}-${optionPosition}`;
    const selector = `input[name="${cssEscape(inputName)}"]:checked`;
    const input = picker.querySelector(selector);

    return input && input.value ? input.value.trim() : "";
  };

  const updateContainer = (container, picker) => {
    const map = getMap(container);
    const optionName = container.dataset.sizeOptionName || "";
    const optionPosition = container.dataset.sizeOptionPosition || "";
    const defaultMessage = (container.dataset.sizeRecoDefaultMessage || "").trim();
    const sizeValue = getSelectedSizeValue(picker, optionName, optionPosition);

    let hasContent = false;
    let items = [];
    if (sizeValue) {
      items = buildMeasurementItems(findEntry(map, sizeValue));
      hasContent = items.length > 0;
    }

    const textEl = container.querySelector(TEXT_SELECTOR);
    if (hasContent) {
      renderItems(textEl, items);
    } else {
      renderDefaultMessage(textEl, defaultMessage);
    }

    container.hidden = !(hasContent || defaultMessage);
  };

  const setupContainer = (container) => {
    if (container.dataset.sizeRecoReady === "true") {
      return;
    }

    container.dataset.sizeRecoReady = "true";
    const picker = container.closest("variant-picker");

    if (!picker) {
      container.hidden = true;
      return;
    }

    updateContainer(container, picker);
  };

  const initSizeReco = (root = document) => {
    root.querySelectorAll(SIZE_RECO_SELECTOR).forEach((container) => {
      setupContainer(container);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initSizeReco());
  } else {
    initSizeReco();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSizeReco(event.target);
  });

  document.addEventListener("shopify:section:select", (event) => {
    initSizeReco(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        if (node.matches(SIZE_RECO_SELECTOR)) {
          setupContainer(node);
        }

        node.querySelectorAll(SIZE_RECO_SELECTOR).forEach((container) => {
          setupContainer(container);
        });
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
